module.exports = __webpack_public_path__ + "ico_quality_requerimientos.png";